// Core
import { connect } from 'react-redux';
// Actions
import { setSelectionByKey } from '../../../../ducks/withShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.withShop.q5.selection,
});

const mapDispatchToProps = {
    setSelectionByKey,
};

const Q5 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q5;